import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import About from "./pages/About/About";
import Compney from "./pages/Compney/Compney";
import Contact from "./pages/Contact/Contact";
import Splash from "./components/Loader/Splash";
import SideNav from "./components/Nav/SideNav";
import MainSlider from "./components/MainSlider/MainSlider";
import Testimonials from "./pages/About/Testimonials";
import Dashboard from "./pages/Dashboard/Dashboard";
import EditAbout from "./pages/Dashboard/EditAbout";
import EditCore from "./pages/Dashboard/EditCore";
import EditInvestorD from "./pages/Dashboard/EditInvestorD";
import EditMainSlider from "./pages/Dashboard/EditMainSlider";
import EditNumbers from "./pages/Dashboard/EditNumbers";
import EditPress from "./pages/Dashboard/EditPress";
import EditStory from "./pages/Dashboard/EditStory";
import EditVisionMission from "./pages/Dashboard/EditVisionMission";
import Sidebar from "./components/Sidebar";
import EditTestimonials from "./pages/Dashboard/EditTestimonials";
import Login from "./pages/Dashboard/Login";

const AppWrapper = () => {
  const [showSplash, setShowSplash] = useState(true);
  const [imgLoading, setImgLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setShowSplash(false);
    }, 3000);
  }, []);

  return (
    <Router>
      <Routes>
        {/* Main route for the landing page */}
        <Route
          path="/"
          element={
            <>
              <div id="App-Overlay">
                {(showSplash || imgLoading) && <Splash />}
                <MainSlider setImgLoading={setImgLoading} />
                <SideNav />
                <About />
                <Compney />
                <Testimonials />
                <Contact />
              </div>
            </>
          }
        />

        {/* Dashboard route with nested sub-routes */}

        {/* Dashboard main route */}
        <Route
          path="/dashboard"
          element={
            <div id="appDash" className="row">
              <Sidebar />
              <main>
                <Dashboard />
              </main>
            </div>
          }
        />

        {/* Sub-routes for each component in the Dashboard */}
        <Route
          path="/dashboard/editAbout"
          element={
            <div id="appDash" className="row">
              <Sidebar />
              <main>
                <EditAbout />
              </main>
            </div>
          }
        />
        <Route
          path="/dashboard/editCore"
          element={
            <div id="appDash" className="row">
              <Sidebar />
              <main>
                <EditCore />
              </main>
            </div>
          }
        />
        <Route
          path="/dashboard/editInvestorD"
          element={
            <div id="appDash" className="row">
              <Sidebar />
              <main>
                <EditInvestorD />
              </main>
            </div>
          }
        />
        <Route
          path="/dashboard/editMainSlider"
          element={
            <div id="appDash" className="row">
              <Sidebar />
              <main>
                <EditMainSlider />
              </main>
            </div>
          }
        />
        <Route
          path="/dashboard/editNumbers"
          element={
            <div id="appDash" className="row">
              <Sidebar />
              <main>
                <EditNumbers />
              </main>
            </div>
          }
        />
        <Route
          path="/dashboard/editPress"
          element={
            <div id="appDash" className="row">
              <Sidebar />
              <main>
                <EditPress />
              </main>
            </div>
          }
        />
        <Route
          path="/dashboard/editStory"
          element={
            <div id="appDash" className="row">
              <Sidebar />
              <main>
                <EditStory />
              </main>
            </div>
          }
        />
        <Route
          path="/dashboard/editTestimonials"
          element={
            <div id="appDash" className="row">
              <Sidebar />
              <main>
                <EditTestimonials />
              </main>
            </div>
          }
        />
        <Route
          path="/dashboard/editVisionMission"
          element={
            <div id="appDash" className="row">
              <Sidebar />
              <main>
                <EditVisionMission />
              </main>
            </div>
          }
        />
        <Route
          path="/dashboard/login"
          element={
            <div id="appDash" className="row">
              <Sidebar />
              <main>
                <Login />
              </main>
            </div>
          }
        />
      </Routes>
    </Router>
  );
};

export default AppWrapper;
